const MAX_SIZE = 10485760;
const MAX_QUANTITY = 3;
const POST_MEETING_ACCEPT =
  'image/png, image/jpeg, image/tiff, image/jpg, application/pdf, audio/mp3, audio/mpeg';
const INITIAL_CONSENT_ACCEPT =
  'image/png, image/jpeg, image/tiff, image/jpg, application/pdf, audio/mp3';
export default {
    MAX_SIZE,
    MAX_QUANTITY,
    POST_MEETING_ACCEPT,
    INITIAL_CONSENT_ACCEPT
};
